import React, {useState} from 'react';
import {NavLink, TabContent, TabPane} from 'reactstrap';
import classnames from 'classnames';
import VideoList from './VideoList';
import AccountLelangList from './AccountLelangList';
import LoadingContent from "./loading-content";

const AccountNavTab = (props) => {
  const [activeTab, setActiveTab] = useState('1');
  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  return(
    <>
      <div className="account-header">
      <h5>Hai, {props.data.msisdn}</h5>
      <ul tabs className="nav nav-tabs">
        <li className="nav-item">
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggle('1'); }}
          >
            Video Likes
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggle('2'); }}
          >
            Lelang<span className="new-notif"></span>
          </NavLink>
        </li>
      </ul>
      </div>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <div className="content video">
            <div className="container">
              <ul className="video-list">
                {!props.likes ? <LoadingContent/> :
                    props.likes.items.map((item, index) => {
                      return <VideoList data={item} />
                    })
                }
              </ul>
            </div>
          </div>
        </TabPane>
        <TabPane tabId="2">
          <div className="content account-lelang">
            <div className="container">
              <ul>
                {!props.myauction ? <LoadingContent/> :
                    props.myauction.items.map((item, index) =>{
                      return <AccountLelangList data={item} />
                    })

                }
              </ul>
            </div>
          </div>
        </TabPane>
      </TabContent>
    </>
  );
}

export default AccountNavTab;
